import { Node, KeyboardShortcutCommand } from "@tiptap/core";
import type { Node as PMNode } from "prosemirror-model";

export interface DeleteTopBlankLineExtensionOptions {
  triggerNodeTypes: string[];
}

export const DeleteTopBlankLineExtension = Node.create<DeleteTopBlankLineExtensionOptions>({
  name: "deleteTopBlankLineHelper",

  addOptions() {
    return {
      triggerNodeTypes: [],
    };
  },

  addKeyboardShortcuts() {
    const isEmptyParagraph = (n: PMNode | null) => n?.type.name === "paragraph" && n.content.size === 0;

    const deleteFirstParagraph: KeyboardShortcutCommand = ({ editor }) => {
      const { state, dispatch } = editor.view;
      const { selection, doc } = state;
      if (!selection.empty) return false;

      const { $from } = selection;
      if ($from.parentOffset !== 0) return false;
      if ($from.pos !== 1) return false;

      const firstNode = doc.child(0);
      if (!isEmptyParagraph(firstNode)) return false;

      if (doc.childCount < 2) return false;
      const secondNode = doc.child(1);
      if (!this.options.triggerNodeTypes.includes(secondNode?.type.name)) return false;

      // Delete the empty paragraph
      dispatch(state.tr.delete(0, firstNode.nodeSize).scrollIntoView());
      return true;
    };

    return {
      Backspace: deleteFirstParagraph,
    };
  },
});
